import SHOP from "./Assets/Projects/shop.jpg";
import TODO from "./Assets/Projects/todo.jpg";
import TASK from "./Assets/Projects/textmate.jpg";


export const PROJECTS = [
  {
    image: SHOP,
    name: "ShopHouse Local",
    technologyUsed: "HTML/Css, Javascript, NodeJs, ExpressJs, MongoDB",
    description: "ShopHouse Local is a team project, developed for connecting local shops to their regular customers by online platform and thus also avoiding hustle of standing in queue in them.",
    url: "https://shophouse-local.onrender.com/",
  },
  {
    image: TASK,
    name: "TextMate",
    technologyUsed: "ReactJS, Material UI, Tailwind CSS, OpenAI API",
    description: "Built a Single Page web application that corrects grammar and enhances sentence tone to professional, curious and more. Users just have to enter a sentence and live it to rest on the application.",
    url: "https://text-mate.vercel.app/",
  },
  {
    image: TODO,
    name: "Task-Tracker WebApp",
    technologyUsed: "HTML, CSS, Javascript, NodeJs, MongoDB",
    description: "Task Tracker is a simple yet effective web app that helps you keep track of your daily tasks and to-dos. With an intuitive interface, you can easily create a list of items you need to complete for the day and mark them as done when finished.",
    url: "https://task-tracker-gept.onrender.com/",
  }
];

export const SKILLS = [
  { name: "C/C++", initialRating: 4 },
  { name: "Python (Basic)", initialRating: 3 },
  { name: "DSA", initialRating: 3 },
  { name: "oops", initialRating: 3 },
  { name: "DBMS", initialRating: 3 },
  { name: "Html", initialRating: 4 },
  { name: "CSS", initialRating: 2 },
  { name: "JavaScript", initialRating: 3 },
  { name: "ReactJs", initialRating: 3 },
  { name: "NodeJs", initialRating: 3 },
  { name: "MongoDB (Atlas)", initialRating: 3 },
  { name: "NumPy | Pandas", initialRating: 2 },
  { name: "Git", initialRating: 3 },
];

export const TOOLS = [
  "Visual Studio Code",
  "Git",
  "Codepen",
  "Jupyter Notebook",
  "Linux Terminal",
  "Vercel for Hosting",
  "MongoDB Atlas for Database",
]
